/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Sep 28 2022
*  File : AppOpenEvaluationExecutor.ts
*******************************************/


import { isSubmitPersonalDataCompletion, SubmitPersonalDataCompletion } from "../../EvaluatedAction.js";
import { ClientSdkPublicInterface } from "../../../sdk/ClientSdkPublicInterface.js";
import { Logger } from "@ciaopeople/cp-shatsu/Logging";
import { CTAExecutionResult, EvaluatedActionExecutor, isDismissedCTA, NamedCtaEvaluator } from "../EvaluatedActionExecutor.js";
import { AuthProviderIdentifier } from "../../../login/AuthProviderIdentifier.js";

export class PersonalDataCompletionEvaluationExecutor implements EvaluatedActionExecutor {
    public isExpectedType = isSubmitPersonalDataCompletion;

    constructor(
        private readonly sdk: ClientSdkPublicInterface,
        private logger: Logger
    ) {

    }

    execute(evaluator: NamedCtaEvaluator, res: SubmitPersonalDataCompletion, data?: any ): Promise<CTAExecutionResult> {
        if(res.data && res.data.dataToComplete && res.data.dataToComplete.length > 0) {
            const hintProvider = res.data.hintProvider && ( res.data.hintProvider.toLowerCase() == AuthProviderIdentifier.APPLE ) ? AuthProviderIdentifier.APPLE : AuthProviderIdentifier.GOOGLE;
            this.logger.debug("showing data completion provider vs hintProvider", res.data.hintProvider.toLowerCase(), hintProvider);

            return this.sdk.getGui().then(
                gui => {
                    return gui.showPersonalDataCompletionScreen(hintProvider, res.data).then(response => {
                        if (isDismissedCTA(response)) {
                            this.logger.debug("User closed the panel manually");
                            return Promise.resolve(CTAExecutionResult.DISMISSED);
                        }
                        else if(response && (response.email ||
                            response.userBirthday ||
                            response.userGender
                        )) {
                            return this.sdk.updatePersonalData(response).then( _r => {
                                this.logger.info("User update completed");
                                return CTAExecutionResult.COMPLETED;
                            });
                        }
                        else {
                            this.logger.info("Nothing to update ... user entered no valid data");
                            return Promise.resolve(CTAExecutionResult.NOT_EXECUTED);
                        }
                    });
                }
            );
        }
        else {
            return Promise.resolve(CTAExecutionResult.NOT_EXECUTED);
        }
    }

}
